export const BASE_APP = {
  actors: [
    'stressed',
    'heartbroken',
    'body_image',
    'traumatised',
    'parent',
    'abused',
    'suicidal_high',
    'grieving',
    'suicidal_medium',
  ],
  assistantFunctions: ['direct', 'generate_response', 'summarize'],
  featureSettings: [
    {
      key: 'generate_response',
      label: 'Propose response',
      description: `Propose a conversational response to the client`,
      isEnabled: true,
      isAutoRun: false,
      isAutoRunnable: true,
    },
    {
      key: 'summarize',
      label: 'Summarise',
      description: `Summarise the conversation`,
      isEnabled: true,
      isAutoRun: false,
      isAutoRunnable: false,
    },
  ],
};
